/* eslint-disable no-unused-vars */
/* These imports are only used by TS typechecker */
import LogoVersion from "./LogoVersion";
import Industry from "./Industry";
import Logo from "./Logo";
/* eslint-enable no-unused-vars */

export default class Brand {
	constructor({id, name = "", industry = {}, logoVersion = [], logo = []} = {}) {
		/** @type {string} */
		this.id = id;
		this.name = name;
		/** @type {Industry} */
		this.industry = industry;
		/** @type {LogoVersion[]} */
		this.logoVersions = logoVersion;
		/** @type {Logo[]} */
		this.logos = logo;
	}
}


// WEBPACK FOOTER //
// ./src/models/Brand.js